﻿import { SupportTicketSendEmailRequest } from "../SupportTicketSendEmailRequest";
import { SupportTicketSendEmailResponse } from "../SupportTicketSendEmailResponse";
import { ServiceOptions, serviceRequest } from "@serenity-is/corelib/q";

export namespace SupportTicketService {
    export const baseUrl = 'SupportTicket';

    export declare function SendEmail(request: SupportTicketSendEmailRequest, onSuccess?: (response: SupportTicketSendEmailResponse) => void, opt?: ServiceOptions<any>): JQueryXHR;

    export const Methods = {
        SendEmail: "SupportTicket/SendEmail"
    } as const;

    [
        'SendEmail'
    ].forEach(x => {
        (<any>SupportTicketService)[x] = function (r, s, o) {
            return serviceRequest(baseUrl + '/' + x, r, s, o);
        };
    });
}
